import { render, staticRenderFns } from "./formater-popup.vue?vue&type=template&id=20d248ea"
import script from "./formater-popup.vue?vue&type=script&lang=js"
export * from "./formater-popup.vue?vue&type=script&lang=js"
import style0 from "./formater-popup.vue?vue&type=style&index=0&id=20d248ea&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports